/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Company,
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyTagDetail,
    CompanyTagDetailFromJSON,
    CompanyTagDetailFromJSONTyped,
    CompanyTagDetailToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyWithTags
 */
export interface CompanyWithTags {
    /**
     * 
     * @type {Company}
     * @memberof CompanyWithTags
     */
    company: Company;
    /**
     * 
     * @type {Array<CompanyTagDetail>}
     * @memberof CompanyWithTags
     */
    tags: Array<CompanyTagDetail>;
}

export function CompanyWithTagsFromJSON(json: any): CompanyWithTags {
    return CompanyWithTagsFromJSONTyped(json, false);
}

export function CompanyWithTagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyWithTags {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'company': CompanyFromJSON(json['company']),
        'tags': ((json['tags'] as Array<any>).map(CompanyTagDetailFromJSON)),
    };
}

export function CompanyWithTagsToJSON(value?: CompanyWithTags | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company': CompanyToJSON(value.company),
        'tags': ((value.tags as Array<any>).map(CompanyTagDetailToJSON)),
    };
}


